import React, { useState } from 'react'
import DatePicker from "react-datepicker";

// Components
import ErrorInputWrap from '../../../../utils/error-success/ErrorInputWrap';
import ErrorWrap from '../../../../utils/error-success/ErrorWrap'
import SuccessWrap from '../../../../utils/error-success/SuccessWrap'
import Button from '../../../../utils/Button' 

// CSS
import "../../../../../css/forms/custom-checkbox.css";
import "../../../../../css/forms/datepicker.css";
import Modal from '../../../../modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { getReviewsDateRange } from '../../../../../store/actions/reviews';
// import AdminMassEmailSectorForm from './AdminMassEmailSectorForm';

const AdminMassEmailForm = ({ 
    data, loading, errors, success, handleInputChange, handleDateChange, handleCheckboxChange, handleSubmit 
}) => {
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch();
    const reviewsState = useSelector(state => state.reviews);

    // Open modal and load reviews based on date ranges
    const openModal = () => {
        dispatch(getReviewsDateRange(data.date_start, data.date_end));
        setShowModal(true);
    }
    
    return (
        <div className="fieldset">
			<div className="title-label">Mass Email Options</div>
            
            <div className="fieldset-indent">
                <div className="form-field">
                    <label>Email Subject:</label>
                    <ErrorInputWrap error={errors.subject}>
                        <input 
                            type="text" 
                            id="subject"
                            value={data.subject || ''}
                            maxLength="500"
                            onChange={e => handleInputChange(e)}
                        />
                    </ErrorInputWrap>
                </div>
                <div className="form-field">
                    <label>Email Content:</label>
                    <ErrorInputWrap error={errors.content}>
                        <input 
                            type="text" 
                            id="content"
                            value={data.content || ''}
                            maxLength="500"
                            onChange={e => handleInputChange(e)}
                        />
                    </ErrorInputWrap>
                </div>

                <div className="form-field">
                    <label>French Email Content:</label>
                    <ErrorInputWrap error={errors.content}>
                        <input 
                            type="text" 
                            id="content_fr"
                            value={data.content_fr || ''}
                            maxLength="500"
                            onChange={e => handleInputChange(e)}
                        />
                    </ErrorInputWrap>
                </div>

                <h3 className='pt2'>Site Visit Date Ranges</h3>
                <div>Select a date range for the site visits of reviews. After selecting the data range, a list of the relevant reviews will show. The mass email will send out reviews to users with profiles matching these reviews.</div>
				<div className="floated-field-container">
                    <div className="form-field half-field">
                        <label>Date Range Start:</label>
                        <ErrorInputWrap error={errors.date_start}>
                            <DatePicker 
    							className="date"
                                selected={data.date_start || null}
                                onChange={date => handleDateChange(date, 'date_start')}
                                dateFormat="LL"
                                placeholderText="Click to select a date"
                            />
                        </ErrorInputWrap>
                    </div>
                    <div className="form-field half-field">
                        <label>Date Range End:</label>
                        <ErrorInputWrap error={errors.date_end}>
                            <DatePicker 
    							className="date"
                                selected={data.date_end || null}
                                disabled={data.date_start === null}
                                onChange={date => handleDateChange(date, 'date_end')}
                                dateFormat="LL"
                                minDate={data.date_start || null}
                                placeholderText="Click to select a date"
                            />
                        </ErrorInputWrap>
                    </div>
                </div>

                {/* Modal - Click button to show modal */}
                <button 
                    className="btn btn--neutral" 
                    onClick={() => openModal()}
                    disabled={data.date_start === null}
                >
                    See Matching Reviews
                </button>

                {showModal && 
                    <Modal 
                        title={`Matching Reviews (${data.date_start.format('YYYY-MM-DD')} - ${data.date_end.format('YYYY-MM-DD')})`}
                        buttons={[]}
                        onClose={() => setShowModal(false)}
                    >
                        <div>
                            {!!reviewsState && !!reviewsState.dateRangeReviews
                                && reviewsState.dateRangeReviews.reviews.map((item) => (
                                    <div>{item.organization_title} - {item.site_visit_starts}</div>
                                ))
                            }
                        </div>
                    </Modal>
                }

                <div className="btn_container pt1">
                    {!!errors.general && (
                        <ErrorWrap animate={1}>{errors.general}</ErrorWrap>
                    )}
                    {success && <SuccessWrap>{success}</SuccessWrap>}

                    <Button
                        text="Save Options"
                        clickHandler={() => handleSubmit()}
                        isLoading={loading}
                    />
                </div>
            </div>

			{/* <div className="title-label pt1">Sectors</div>
            <div className="fieldset-indent">
                <div className="form-field">
                    <AdminMassEmailSectorForm 
                        errors={errors}
                        handleSectorCheckboxChange={(e) => handleSectorCheckboxChange(e)}
                    />
                </div>
            </div> */}
        </div>
    )
}

export default AdminMassEmailForm



// WEBPACK FOOTER //
// ./src/components/admin/reviews/reviews-email/mass-email/AdminMassEmailForm.js